import { HashRouter, Route, Routes } from 'react-router-dom';
import useUser from 'store/user/useUser';

import Main from './Main';
import MyPage from './MyPage';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ScreenSetting from './ScreenSetting';
import AgreementTow from './AgreementTow';
import CheckHealthBaby from './CheckHealthBaby';
import CoreSkillVideo from './StudentManagement';

function RouterContainer() {
  const { student_uuid, student_grade } = useUser();

  if (!student_uuid)
    return (
      <HashRouter>
        <Routes>
          <Route path="*" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
        </Routes>
      </HashRouter>
    );

  if (student_grade === 2 || student_grade === 5) {
    return (
      <HashRouter>
        <Routes>
          <Route path="*" element={<Main />} />
          <Route path="/mypage" element={<MyPage />} />
          <Route path="/agreement2" element={<AgreementTow />} />
          <Route path="/badyMedicalCheckup" element={<CheckHealthBaby />} />
          <Route path="/screensetting" element={<ScreenSetting />} />
          <Route path="/professorAuth" element={<CoreSkillVideo />} />
          <Route
            path="/professorAuth/assignment"
            element={<CoreSkillVideo />}
          />
          <Route path="/professorAuth/list" element={<CoreSkillVideo />} />
          <Route path="/professorAuth/record" element={<CoreSkillVideo />} />
          <Route path="/professorAuth/video" element={<CoreSkillVideo />} />
          <Route path="/professorAuth/modify" element={<CoreSkillVideo />} />
          <Route
            path="/professorAuth/classSection"
            element={<CoreSkillVideo />}
          />
        </Routes>
      </HashRouter>
    );
  }
  return (
    <HashRouter>
      <Routes>
        <Route path="*" element={<Main />} />
        <Route path="/mypage" element={<MyPage />} />
        <Route path="/agreement2" element={<AgreementTow />} />
        <Route path="/badyMedicalCheckup" element={<CheckHealthBaby />} />
        <Route path="/screensetting" element={<ScreenSetting />} />
      </Routes>
    </HashRouter>
  );
}

export default RouterContainer;
